const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
    {
    path: "/salud",
    exact: true,
    component: "Salud",
  },
     {
    path: "/rcv",
    exact: true,
    component: "RCV",
  },
  {
    path: "/formulariorcv",
    exact: true,
    component: "FormularioRCV",
  },
    {
    path: "/formulariosalud",
    exact: true,
    component: "FormularioSalud",
  },
];

export default routes;